export default function priceGenerator(price, withoutCurrency) {
  if (price === -2 || !price) return 'تماس بگیرید';
  if (price === -1 || !price || price < 0) return 'توافقی';
  if (price > 0)
    return (
      price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') +
      (withoutCurrency ? '' : ' تومان')
    );
}
